module.exports = __webpack_public_path__ + "static/img/facilities-text-3.134a707d.png";